import { styled } from "@mui/material";
import { Col, Container, Row } from "@plataformaxvia/design-system";

export const FullHeightContainer = styled(Container)({
  height: "100%",
  margin: "32px 0",
});

export const FullHeightRow = styled(Row)({
  height: "100%",
});

export const PageText = styled("span")({
  color: "#ffffff",
  textAlign: "center",
  maxWidth: "100%",
  padding: 32,
});

export const WhiteCard = styled(Col)({
  width: "100%",
  background: "#ffffff",
  borderRadius: 4,
  boxSizing: "border-box",
});

export const WhiteCardContent = styled(Row)({
  padding: 32,
});

export const SignInGovBrButtonContainer = styled("div")({
  paddingTop: 16,
  paddingBottom: 32,
});

interface DisclaimerTextProps {
  isSmallScreen: boolean;
}

export const DisclaimerText = styled("p")((props: DisclaimerTextProps) => ({
  fontSize: 14,
  color: "#6c757d",
  textAlign: props.isSmallScreen ? "center" : "left",
}));

export const Separator = styled("hr")({
  border: 0,
  borderTop: "1px solid #e5e5e5",
  width: "100%",
});

export const HelpSection = styled(Row)({
  width: "100%",
});

export const HelpTitle = styled("h4")({
  fontSize: 16,
  fontWeight: "bold",
});

export const HelpLink = styled("a")({
  fontSize: 12,
  textDecoration: "underline",
  display: "inline-flex",
  alignItems: "center",
  gap: 4,
  "& .MuiSvgIcon-root": {
    fontSize: "inherit",
  },
});
